<template>
  <div class="main">
    <span class="main-config">
      <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
        <label>{{ $t('operacoes') }} </label>
        <b-form-select
          class="input-pentagro"
          v-model="operationSelected"
          :options="operations"
        ></b-form-select>
      </div>
      <b-form v-if="operationSelected" class="b-layout">
          <b-card v-if="equipments.length > 0">
            <div v-for="(prop, index) in equipments" :key="prop.caption + index">
              <b-form-checkbox
                class="switch-item"
                v-model="prop.value"
                @change="ChangeOnOff($event, prop)"
                switch
                >
                {{ prop.equipName }}
              </b-form-checkbox>
            </div>
          </b-card>
          <b-card v-else>
            <label class="eqMsgTxt">{{ $t('operacao-sem-equipamentos') }}</label>
          </b-card>
        <div class="ml-3 attrsValuesGroup">
          <b-card>
            <div v-if="showDGroup" class="regeneratorDGroup box-edit">
              <span class="mt-2" v-if="TSaidaFluido1">
                <label>{{ $t('temperatura-saida-1-c') }}</label>
                <b-input class="inputAttrValue" v-model="TSaidaFluido1.value" min="0" type="number"></b-input>
              </span>

              <span v-if="TSaidaFluido1">
                <label>{{ $t('temperatura-saida-2-c') }}</label>
                <b-input class="inputAttrValue" v-model="TSaidaFluido2.value" min="0" type="number"></b-input>
              </span>

              <span v-if="TSaida">
                <label>{{ $t('temperatura-saida-c') }}</label>
                <label>{{ TSaida.value | ParseNumber }}</label>
              </span>
            </div>
            <div class="inp" v-if="area">
              <label>{{ $t('area-m-1') }} </label>
              <label>{{ area.value | ParseNumber }}</label>
            </div>
            <div class="inp" v-if="TaxaOcupacao">
              <label>{{ $t('ocupacao-1') }} </label>
              <label>{{ TaxaOcupacao.value | ParseNumber }}</label>
            </div>
          </b-card>
        </div>
      </b-form>
    </span>
    <div v-if="jokerEquipmentList.length && operationSelected" class="joker">
      <label class="mt-2 ml-2">{{ $t('equipamentos-coringas') }}</label>
      <div v-for="(joker, i) in jokerEquipmentList" :key="i">
        <b-form>
          <div class="ml-2 mr-2">
            <TextToInput 
              :text="joker.caption"
              @sendText="updateCaption($event, joker)">
            </TextToInput>
          </div>
          <span class="b-layout">
            <b-card v-if="equipments.length > 0">
              <div v-for="(prop, index) in joker.equipments" :key="prop.caption + index">
                <b-form-checkbox
                  class="switch-item"
                  v-model="prop.value"
                  @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                  switch
                  >
                  {{ prop.equipName }}
                </b-form-checkbox>
              </div>
            </b-card>
            <div class="ml-3" v-if="equipments.length > 0">
              <b-card>
                <div class="inp mb-2">
                  <label>{{ $t('area-m-1') }} </label>
                  <label class="input-data" >{{ joker.capacidade.value | ParseNumber }}</label>
                </div>
                <div class="inp">
                  <label>{{ $t('ocupacao-1') }} </label>
                  <label class="input-data">{{ joker.Ocupacao.value | ParseNumber}}</label>
                </div>
              </b-card>
            </div>
          </span>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { JokerEquipmentMixin } from '../../../mixins/jokerEquipmentsMixin'
import { FiltersMixin }  from '../../../mixins/filtersMixin'
import { ParseToNumber } from "../../utils/tools";
import TextToInput from "../../../template/TextToInput"

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
     readOnly:{
      type: Boolean,
      default: false,
    }
  },

  components: { TextToInput },
 
  mixins: [ JokerEquipmentMixin, FiltersMixin ],

  data() {
    return {
      attrList: ["area", "TaxaOcupacao", "TSaida", "TSaidaFluido1", "TSaidaFluido2", "Enabled" ],
      area: {},
      Enabled: {},
      TaxaOcupacao: {},
      TSaidaFluido1: {},
      TSaidaFluido2: {},
      TSaida: {},
      operations: [{ value: null, text:this.$t('selecione-uma-operacao'), disabled: true}],
      operationSelected: null,
      operationAttributeList: [],
      firstLoad: false,
      equipments: [],
      equipCap: [],
      showDGroup: false
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();
      this.buildJokerEquipment(value)

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      let opAttrsListToCheck = []
      if(this.operationAttributeList){
        this.operationAttributeList.forEach( x => opAttrsListToCheck.push(x.caption))
      }


      if(opAttrsListToCheck.includes("TSaidaFluido1") || opAttrsListToCheck.includes("TSaidaFluido2") || opAttrsListToCheck.includes("TSaida")){
        this.showDGroup = true
      }
      else{        
        this.showDGroup = false
      }
      
      if (opAttrsListToCheck.includes(this.attrList[0])) {
        this.area = this.operationAttributeList.find(
          (p) => this.attrList[0] == p.caption
        );
      }
      else
        delete this.$data[this.attrList[0]]

      if (opAttrsListToCheck.includes(this.attrList[1])) {
        this.TaxaOcupacao = this.operationAttributeList.find(
          (p) => this.attrList[1] == p.caption
        );
      }
      else
        delete this.$data[this.attrList[1]]

      if(opAttrsListToCheck.includes(this.attrList[2])){
        this.TSaida = this.operationAttributeList.find(
          (p) => this.attrList[2] == p.caption
        );
      }
      else
        delete this.$data[this.attrList[2]]

      if(opAttrsListToCheck.includes(this.attrList[3])){
        this.TSaidaFluido1 = this.operationAttributeList.find(
          (p) => this.attrList[3] == p.caption
        );
      }
      else
        delete this.$data[this.attrList[3]]

      if(opAttrsListToCheck.includes(this.attrList[4])){
        this.TSaidaFluido2 = this.operationAttributeList.find(
          (p) => this.attrList[4] == p.caption
        );
      }

      if(opAttrsListToCheck.includes(this.attrList[5])){
        this.Enabled = this.operationAttributeList.find(
          (p) => this.attrList[5] == p.caption
        );
      }
      else
        delete this.$data[this.attrList[5]]

      opAttrsListToCheck.forEach( attrName => this.setAttrsOperationsValues(attrName))
      this.updateNode();
    },

    "TSaidaFluido1.value"() {
      this.updateNode();
    },

    "TSaidaFluido2.value"() {
      this.updateNode();
    },
    
    "TSaida.value"() {
      this.updateNode();
    },

    "area.value"() {
      this.updateNode();
    }
  },

  methods: {
    loadNode() {
      if (this.node.data.length > 0) {
        if (this.node.data[0].index) {
          this.buildJokerEquipment(this.node.data[0].index, this.node.jokerCaption)
          this.firstLoad = true;
          this.operationSelected = this.node.data[0].index;
          this.loadNotInput();
          this.loadOperationProperties();
        }
      }

      this.equipments = new Array();
      
      this.node.data.forEach((p) => {
        if (p.equipName) {
          let equip = p.clone();
          equip.value = parseInt(equip.value) ? true : false;
          
          this.equipments.push(equip);
        }
        else{
          this[p.key] = p
          this.setAttrsOperationsValues(p.caption)
        }
      });
      this.loadEquipments();
    },

    setAttrsOperationsValues(attrName){
      if (attrName == "area" && this.area)
          this.area.value = isNaN(parseFloat(this.area.value)) 
            ? ParseToNumber("0.0")
            : ParseToNumber(this.area.value)

        if (attrName == "TaxaOcupacao" && this.TaxaOcupacao)
          this.TaxaOcupacao.value = isNaN(parseFloat(this.TaxaOcupacao.value))
            ? ParseToNumber("0.0")
            : ParseToNumber(this.TaxaOcupacao.value);
        
        if (attrName == "TSaidaFluido1" && this.TSaidaFluido1)
        this.TSaidaFluido1.value = isNaN(parseFloat(this.TSaidaFluido1.value))
          ? ParseToNumber("0.0")
          : ParseToNumber(this.TSaidaFluido1.value);

        if (attrName == "TSaidaFluido2" && this.TSaidaFluido2)
          this.TSaidaFluido2.value = isNaN(parseFloat(this.TSaidaFluido2.value))
            ? ParseToNumber("0.0")
            : ParseToNumber(this.TSaidaFluido2.value)
        
        if (attrName == "TSaida" && this.TSaida)
          this.TSaida.value = isNaN(parseFloat(this.TSaida.value))
            ? ParseToNumber("0.0")
            : ParseToNumber(this.TSaida.value)

        if(this.TSaidaFluido1 || this.TSaidaFluido2 || this.TSaida)
          this.showDGroup = true
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = ["area", "TaxaOcupacao", "TSaidaFluido1", "TSaidaFluido2", "TSaida"];

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );
        this.setAttrsOperationsValues(attrName);        
        });
    },

    updateNode() {
      let attrs = [this.Enabled];

      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? '1,00' : '0,00';
        attrs.push(prop);
      });

      if(this.TSaidaFluido1 && this.TSaidaFluido1.key)
        attrs.push(this.TSaidaFluido1.clone())

      if(this.TSaidaFluido2 && this.TSaidaFluido2.key)
        attrs.push(this.TSaidaFluido2.clone())
      
      if(this.TSaida && this.TSaida.key)
        attrs.push(this.TSaida.clone())

      if(this.area && this.area.key)
        attrs.push(this.area.clone())

      this.node.attrs = attrs;
      this.updateJokerNode(this.node, this.jokerEquipmentList)
    },

    loadOperationProperties(){
      let equipmentProps = SingletonEnginnering.getOperationsProperties(this.operationSelected)
      this.attrList.forEach(attr => {
        let prop = equipmentProps.find(p => p.key == attr)
        if(prop)
          this[attr] = prop
      })
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );

      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );

      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Status") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }
          if (props[p].caption == "Capacidade") {
            if (props[p].strValue != "") {
              props[p].value = props[p].strValue;
            }
            this.equipCap.push(props[p]);
          }
        });
      });
      this.equipments = auxEquipment;
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacidade();
      this.switchStatusJoker(prop, this.equipments, false, this.Changecapacidade)
      this.updateNode();
    },

    ChangeCapacidade() {
      if (this.equipments && this.equipments.length > 0 && this.area) {
        this.area.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCap.find((c) => c.equipName == e.equipName);
          if (e.value && cap)
            this.area.value += parseFloat(String(cap.value).replace(",", "."));

          if(this.area.value == 0){
            this.Enabled.value = "false"
          }else{
            this.Enabled.value = "true"
          }
        });
      }
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) => o.match(/Regenerador/));
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeCapacidade();
    this.changeExternalCapacity = function () { this.ChangeCapacidade() }
    this.updataNodeInMixin = function () { this.updateNode() }
  },
};
</script>

<style scoped>
.main{
  display: flex;
}

.main-config{
  width: 530px;
}

.width-155{
  width: 155px;
}

.input-data{
  width: 80px;
  text-align: right;
}

form {
  padding: 10px;
  color: #0009;
}

.b-layout {  
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.regeneratorDGroup{
  width:250px;
}

.attrsValuesGroup{
  min-width: 290px;
}

.eqMsgTxt {
  text-align: center;
}

.box-edit>span{
  display: flex;
  justify-content: space-between;
}

.box-edit>span>input{
  width: 80px;
  height: 25px;
  text-align: right;
  border: #ff5f00 solid 1px;
}

.inputAttrValue{
  padding: 0px;
}
</style>